import { configureStore } from '@reduxjs/toolkit';
import UiReducer from './slices/ui.slice';
import ApiReducer from './slices/api.slice';


import authReducer from './slices/auth.slice';
import userReducer from './slices/user.slice';
import clientReducer from './slices/client.slice';
import fournisseurReducer from './slices/fournisseur.slice';
import magasinReducer from './slices/magasin.slice';
import grpMagasinReducer from './slices/group-magasin.slice';
import userAccessReducer from './slices/user-access.slice';
import dataAccessReducer from './slices/data-access.slice';

import catalogueReducer from './slices/catalogue.slice';
import catalogueDiamantReducer from './slices/catalogue-diamant.slice';

import CmdFournisseurReducer from './slices/commande-fournisseur.slice';
import ArrivageFBReducer from './slices/arrivage-fb.slice';
import FactureFBReducer from './slices/facture-fb.slice';

import DocDiamantFBReducer from './slices/doc-diamant-fb.slice';
import StockDiamantReducer from './slices/stock-diamant.slice';


import StockDiamantFbReducer from './slices/stock-diamant-fb.slice';

import CaisseReducer from './slices/caisse.slice';
import reparationReducer from './slices/reparation.slice';
import stripeReducer from './slices/stripe.slice';
import TacheReducer from './slices/tache.slice';
import RdvReducer from './slices/rdv.slice';
import VpReducer from './slices/vente-privee.slice';


import { listenerMiddleware } from './slice.middleware';


export const store = configureStore({
  reducer: {
    ui_store: UiReducer,
    api_store: ApiReducer,
    auth_store: authReducer,
    user_store: userReducer,
    client_store: clientReducer,
    fournisseur_store: fournisseurReducer,
    magasin_store: magasinReducer,
    groupe_magasin_store: grpMagasinReducer,
    user_access_store: userAccessReducer,
    data_access_store: dataAccessReducer,
    
    catalogue_store: catalogueReducer,
    catalogue_dia_store: catalogueDiamantReducer,

    cmd_achat_store: CmdFournisseurReducer,
    arrivage_fb_store: ArrivageFBReducer,
    facture_fb_store: FactureFBReducer,

    doc_diamant_fb_store: DocDiamantFBReducer,
    stock_diamant_store: StockDiamantReducer,

    stock_diamant_fb_store: StockDiamantFbReducer,

    caisse_store : CaisseReducer,
    reparation_store : reparationReducer,
    stripe_store : stripeReducer,
    tache_store : TacheReducer,
    rdv_store : RdvReducer,

    vp_store : VpReducer,
  },
   middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().prepend(listenerMiddleware.middleware),
});
